"use client";

import React from "react";
import { MapPin, Clock, Phone, Mail, Loader, Send } from "lucide-react";
import { FormProvider, useWvcForm } from "@/integrations/forms/FormProvider";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Form, FormField, FormItem, FormLabel, FormControl, FormMessage } from "@/components/ui/form";
import { Card, CardHeader, CardTitle, CardContent } from "@/components/ui/card";
import { Separator } from "@/components/ui/separator";
import { Link } from "@/components/common/Link";
function ContactFormInner() {
  const {
    isSubmitting,
    isSubmitted,
    submitError,
    successMessage,
    handleSubmit,
    control,
    resetForm
  } = useWvcForm();
  if (isSubmitted && !submitError) {
    return <div className="flex flex-col items-center justify-center p-8 text-center space-y-4 bg-white/5 backdrop-blur-sm border border-white/10 rounded-xl animate-in fade-in zoom-in duration-500">
        <div className="size-12 rounded-full bg-green-500/20 flex items-center justify-center text-green-400">
          <Send className="size-6" />
        </div>
        <h3 className="text-xl font-serif text-primary-foreground">
          Messaggio Inviato
        </h3>
        <p className="text-primary-foreground/70">{successMessage}</p>
        <Button onClick={resetForm} variant="outline" className="mt-4 border-primary-foreground/20 text-primary-foreground hover:bg-primary-foreground/10 hover:text-primary-foreground">
          Invia un altro messaggio
        </Button>
      </div>;
  }
  return <Form onSubmit={handleSubmit} className="space-y-6">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <FormField control={control} name="name" rules={{
        required: "Il nome è obbligatorio"
      }} render={({
        field
      }) => <FormItem>
              <FormLabel className="text-primary-foreground/80">
                Nome Completo
              </FormLabel>
              <FormControl>
                <Input placeholder="Mario Rossi" {...field} className="bg-white/5 border-white/10 text-primary-foreground placeholder:text-primary-foreground/30 focus-visible:border-[var(--ring)] focus-visible:ring-[var(--ring)]/20 transition-colors" />
              </FormControl>
              <FormMessage className="text-red-400" />
            </FormItem>} />

        <FormField control={control} name="email" rules={{
        required: "L'email è obbligatoria",
        pattern: {
          value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
          message: "Inserisci un indirizzo email valido"
        }
      }} render={({
        field
      }) => <FormItem>
              <FormLabel className="text-primary-foreground/80">
                Indirizzo Email
              </FormLabel>
              <FormControl>
                <Input type="email" placeholder="mario@esempio.it" {...field} className="bg-white/5 border-white/10 text-primary-foreground placeholder:text-primary-foreground/30 focus-visible:border-[var(--ring)] focus-visible:ring-[var(--ring)]/20 transition-colors" />
              </FormControl>
              <FormMessage className="text-red-400" />
            </FormItem>} />
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <FormField control={control} name="phone" render={({
        field
      }) => <FormItem>
              <FormLabel className="text-primary-foreground/80">
                Telefono (Opzionale)
              </FormLabel>
              <FormControl>
                <Input type="tel" placeholder="+39 333 123 4567" {...field} className="bg-white/5 border-white/10 text-primary-foreground placeholder:text-primary-foreground/30 focus-visible:border-[var(--ring)] focus-visible:ring-[var(--ring)]/20 transition-colors" />
              </FormControl>
              <FormMessage className="text-red-400" />
            </FormItem>} />

        <FormField control={control} name="subject" render={({
        field
      }) => <FormItem>
              <FormLabel className="text-primary-foreground/80">
                Oggetto
              </FormLabel>
              <FormControl>
                <Input placeholder="Richiesta informazioni..." {...field} className="bg-white/5 border-white/10 text-primary-foreground placeholder:text-primary-foreground/30 focus-visible:border-[var(--ring)] focus-visible:ring-[var(--ring)]/20 transition-colors" />
              </FormControl>
              <FormMessage className="text-red-400" />
            </FormItem>} />
      </div>

      <FormField control={control} name="message" rules={{
      required: "Il messaggio è obbligatorio"
    }} render={({
      field
    }) => <FormItem>
            <FormLabel className="text-primary-foreground/80">
              Messaggio
            </FormLabel>
            <FormControl>
              <Textarea placeholder="Scrivi qui il tuo messaggio..." className="min-h-[150px] bg-white/5 border-white/10 text-primary-foreground placeholder:text-primary-foreground/30 focus-visible:border-[var(--ring)] focus-visible:ring-[var(--ring)]/20 transition-colors resize-none" {...field} />
            </FormControl>
            <FormMessage className="text-red-400" />
          </FormItem>} />

      {submitError && <div className="p-4 bg-red-500/10 border border-red-500/20 rounded-lg">
          <p className="text-red-400 text-sm">{submitError}</p>
        </div>}

      <Button type="submit" disabled={isSubmitting} className="w-full md:w-auto bg-[var(--ring)] text-primary hover:bg-[var(--ring)]/90 font-medium px-8 py-6 text-base transition-all duration-300 shadow-[0_0_20px_-5px_var(--ring)] hover:shadow-[0_0_25px_-5px_var(--ring)]">
        {isSubmitting ? <>
            <Loader className="mr-2 size-5 animate-spin" />
            Invio in corso...
          </> : "Invia Richiesta"}
      </Button>
    </Form>;
}
export default function MailAndCorrespondence() {
  return;
}